import { render, staticRenderFns } from "./RecentVessels.vue?vue&type=template&id=66845e57&scoped=true&"
import script from "./RecentVessels.vue?vue&type=script&lang=js&"
export * from "./RecentVessels.vue?vue&type=script&lang=js&"
import style0 from "./RecentVessels.vue?vue&type=style&index=0&id=66845e57&scoped=true&lang=css&"
import style1 from "./RecentVessels.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66845e57",
  null
  
)

export default component.exports